/**
 *
 *
 *
 *
 *
 *
 *
 */
import { useSyncExporter } from "../common/useSyncExporter.js";
import { attributeParserSync, type AttributeParserSync } from "../globals/attribute-parser.js";

/*                                    */
export { attributeParserSync as attributeParser };

const asExport = useSyncExporter(({ o_util }) => o_util.attributeParser);

/**
 *
 *
 */
export const parseParameters: AttributeParserSync["parseParameters"] = asExport("parseParameters");

/**
 *
 */
export const parseAttributeName: AttributeParserSync["parseAttributeName"] =
  asExport("parseAttributeName");

/**
 *
 *
 *
 */
export const mergeParameterValues: AttributeParserSync["mergeParameterValues"] =
  asExport("mergeParameterValues");
